import React from 'react';

import { ToastConfig } from '.';

export const ToastContext = React.createContext<{
  createToast: (titleOrConfig: ToastConfig | string) => void;
}>({
  createToast: () => {
    console.error('ToastContext not initialized');
  },
});
